import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df115b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PolicyEnrollment = _resolveComponent("PolicyEnrollment")!
  const _component_PolicyConfiguration = _resolveComponent("PolicyConfiguration")!
  const _component_DodoTabs = _resolveComponent("DodoTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, "Policy: " + _toDisplayString(_ctx.policy.name), 1),
    _hoisted_1,
    _createVNode(_component_DodoRow, { gap: "s" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (parent, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: parent.id,
            class: "mdm-white-panel"
          }, [
            _createElementVNode("h4", null, [
              _createVNode(_component_DodoIcon, {
                name: "receipt_long",
                large: ""
              }),
              (index == 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Base")
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(" Parent: "),
              _createVNode(_component_router_link, {
                to: `/policies/${parent.id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(parent.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_DodoTabs, { tabs: [
      { name: 'Enrollment', slot: 'enrollment' },
      { name: 'Configuration', slot: 'configuration' },
    ] }, {
      enrollment: _withCtx(() => [
        _createVNode(_component_PolicyEnrollment)
      ]),
      configuration: _withCtx(() => [
        _createVNode(_component_PolicyConfiguration)
      ]),
      _: 1
    })
  ], 64))
}